import { ChevronRight, Info } from "lucide-react";

const GoogleDisplayPreview = ({ imageUrl, headline, description }) => {
  return (
    <div className="flex justify-center h-full w-full">
      <div className="flex flex-col h-full w-[75%] max-w-[600px] border border-gray-border shadow-card rounded-md overflow-hidden bg-white">
        {/* Imagen */}
        <div className="relative flex-1 min-h-[100px] overflow-hidden">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Google Display Ad"
              className="object-cover w-full h-full"
            />
          ) : (
            <div className="w-full h-full bg-gray-200" />
          )}

          <div className="absolute top-0 right-0 bg-white rounded-sm px-[2px] py-[1px] flex items-center gap-1 text-[10px] text-blue-300 font-medium">
            <Info size={16} strokeWidth={3} />
          </div>
        </div>

        {/* Headline */}
        <div className="bg-[#B91C1C] px-4 py-2">
          <h3 className="text-white font-bold text-sm leading-tight break-words">
            {headline || "Título del anuncio"}
          </h3>
        </div>

        {/* Descripción + CTA */}
        <div className="px-4 py-3 flex justify-between items-center gap-2">
          <p className="text-sm text-gray-800 line-clamp-2 break-words flex-1 min-w-0">
            {description || "Descripción de muestra del anuncio."}
          </p>
          <div className="w-8 h-8 rounded-full bg-black text-white flex items-center justify-center shrink-0">
            <ChevronRight size={16} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleDisplayPreview;
